// extracted by mini-css-extract-plugin
export default {"card":"MoodTermsCard_card__9N2rT","block":"MoodTermsCard_block__R1c6w","cardTitle":"MoodTermsCard_cardTitle__X3wkr"};